import React, { useState } from 'react';
import { Container, Table, Button, Row, Col } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const SummaryReports = () => {
  // Summary data
  const summaryData = [
    { voucher: 'Total Balance', amount: 4379514 },
    { voucher: 'Total Payout Balance', amount: 299994 },
    { voucher: 'Total Commission', amount: 184749 },
    { voucher: 'Admin Balance', amount: 299900 },
    { voucher: 'Admin Commission', amount: 99 },
    { voucher: 'Refund Pending', amount: 91510 },
    { voucher: 'Retailer Balance', amount: 30017 },
    { voucher: 'Retailer Commission', amount: -19 },
    { voucher: 'Distributor Balance', amount: 0 },
    { voucher: 'Distributor Commission', amount: 0 },
    { voucher: 'MD Balance', amount: 0 },
    { voucher: 'MD Commission', amount: 0 },
    { voucher: 'Whitelabel Balance', amount: 0 },
    { voucher: 'Whitelabel Commission', amount: 0 },
    { voucher: 'API Partner Balance', amount: 0 },
    { voucher: 'API Partner Commission', amount: 0 }
  ];

  // Export to Excel function
  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(summaryData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Summary Reports');
    XLSX.writeFile(workbook, `Summary_Reports_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // Format number with commas
  const formatAmount = (amount) => {
    return amount.toLocaleString('en-IN');
  };

  return (
    <Container fluid className="">
      <div className="user-table-container">
        {/* Header with Title and Export */}
        <Row className="mb-3 g-2 align-items-center">
          <Col lg={6} md={6} sm={12}>
            <h4 className="mb-0" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
              Summary Reports
            </h4>
          </Col>
          <Col lg={6} md={6} sm={12} className="d-flex justify-content-end gap-2">
            <Button 
              size="sm" 
              variant="success" 
              onClick={handleExportExcel}
              style={{
                padding: '0.4rem 1rem 0.5rem 1rem',
                fontSize: '0.875rem',
                height: 'auto'
              }}
            >
              <i className="bi bi-file-earmark-excel me-1"></i> Excel
            </Button>
          </Col>
        </Row>

        {/* Summary Table */}
        <div className="table-responsive">
          <Table bordered hover className="modern-table mb-0">
            <thead 
              style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                color: 'white',
                position: 'sticky',
                top: 0,
                zIndex: 10
              }}
            >
              <tr>
                <th 
                  style={{
                    padding: '12px 16px',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    textAlign: 'left',
                    borderBottom: '2px solid rgba(255,255,255,0.2)',
                    width: '60%'
                  }}
                >
                  Voucher
                </th>
                <th 
                  style={{
                    padding: '12px 16px',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    textAlign: 'center',
                    borderBottom: '2px solid rgba(255,255,255,0.2)',
                    width: '40%'
                  }}
                >
                  Total Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {summaryData.map((item, index) => (
                <tr 
                  key={index}
                  style={{ 
                    background: '#f0f2f5',
                    transition: 'background 0.2s ease'
                  }}
                  className="summary-row"
                >
                  <td 
                    style={{
                      padding: '12px 16px',
                      fontSize: '0.875rem',
                      verticalAlign: 'middle',
                      textAlign: 'left',
                      color: '#475569',
                      fontWeight: '500'
                    }}
                  >
                    {item.voucher}
                  </td>
                  <td 
                    style={{
                      padding: '12px 16px',
                      fontSize: '0.875rem',
                      verticalAlign: 'middle',
                      textAlign: 'center',
                      color: item.amount < 0 ? '#dc2626' : '#0f172a',
                      fontWeight: '600'
                    }}
                  >
                    {formatAmount(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Add custom hover effect */}
        <style>{`
          .summary-row:hover {
            background: #e2e8f0 !important;
            cursor: default;
          }
        `}</style>
      </div>
    </Container>
  );
};

export default SummaryReports;

